import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as SectionQL from "queries/section";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params,
    params: { siteId, sectionId },
  },
}) => {
  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the section <b>{sectionId}</b>? This action will be
            permanent and can't be undone.
          </Col>
        </Row>
        <Row>
          <Col>
            {/* Said plainly because nothing prevents it. Pages reference a
                section by name across tables, so checking would be a scan of
                every page on every delete; the renderer reports the dangling
                reference instead, and this is where somebody can still change
                their mind. */}
            <p className="text-muted mt-3 mb-0">
              Any page with an element pointing at this section will render
              "Section not found" in its place.
            </p>
          </Col>
        </Row>
        <Mutation
          mutation={SectionQL.remove}
          update={SectionQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: {
                siteId,
                sectionId
              },
            });
          }}
          onCompleted={() => {
            history.replace(`/site/${siteId}/section`);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
